import React, {Component} from 'react';
import ReactResizeDetector from 'react-resize-detector';
import Gallery from './Gallery';
import './Projects.css';

class Projekts extends Component{
  render(){
    let {doc} = this.props;
    return(
      <div className="Projekts">
        <ReactResizeDetector refreshMode="debounce" refreshRate={300} handleWidth >
          {(width) => <Gallery width={width} doc={doc} /> }
        </ReactResizeDetector>
      </div>
    )
  }
}

export default Projekts;


// WEBPACK FOOTER //
// ./src/components/Projects.js